import { Component, OnInit } from "@angular/core";
import { FinanceiroService } from "./financeiro.service";
import dayjs from "dayjs";
import { firstValueFrom } from "rxjs";

@Component({
  selector: "app-ordemcoleta",
  templateUrl: "./financeiro.component.html",
  styleUrls: ["./financeiro.component.css"],
  standalone: false,
})
export class FinanceiroComponent implements OnInit {
  columns: Array<any>;
  listAVencer: Array<any> = new Array();
  listVencidos: Array<any> = new Array();
  vencidos: string;
  avencer: string;
  isHideLoading = false;
  constructor(
    private financeiroService: FinanceiroService) { }

  lista(): Promise<void> {
    return new Promise(async (resolve, reject) => {
      try {
        const titulos = await firstValueFrom(this.financeiroService.getTitulos(sessionStorage.getItem("cgc")));

        this.vencidos = this.formatReal(titulos[0].TotalVencido);
        this.avencer = this.formatReal(titulos[0].TotalAVencer);
        this.isHideLoading = true;

        // Limpa as listas antes de preencher
        this.listAVencer = [];
        this.listVencidos = [];

        for (let i = 0; i < titulos[0].TitulosAVencer.length; i++) {
          let data =
            titulos[0].TitulosAVencer[i].VENCTO.substring(0, 4) +
            "-" +
            titulos[0].TitulosAVencer[i].VENCTO.substring(4, 6) +
            "-" +
            titulos[0].TitulosAVencer[i].VENCTO.substring(6, 8);
          this.listAVencer.push({
            empresa: titulos[0].TitulosAVencer[i].EMPRESA,
            numero: titulos[0].TitulosAVencer[i].NUMERO,
            parcela: titulos[0].TitulosAVencer[i].PARCELA,
            vencimento: data,
            valor: this.formatReal(titulos[0].TitulosAVencer[i].SALDO),
          });
        }

        for (let i = 0; i < titulos[0].TitulosVencidos.length; i++) {
          let data =
            titulos[0].TitulosVencidos[i].VENCTO.substring(0, 4) +
            "-" +
            titulos[0].TitulosVencidos[i].VENCTO.substring(4, 6) +
            "-" +
            titulos[0].TitulosVencidos[i].VENCTO.substring(6, 8);
          this.listVencidos.push({
            empresa: titulos[0].TitulosVencidos[i].EMPRESA,
            numero: titulos[0].TitulosVencidos[i].NUMERO,
            parcela: titulos[0].TitulosVencidos[i].PARCELA,
            vencimento: data,
            valor: this.formatReal(titulos[0].TitulosVencidos[i].SALDO),
          });
        }

        resolve(); // Resolve a Promise após o processamento
      } catch (error) {
        console.error("Erro ao buscar títulos:", error);
        this.isHideLoading = true; // Certifique-se de esconder o loading mesmo em caso de erro
        reject(error); // Rejeita a Promise em caso de erro
      }
    });
  }

  async ngOnInit() {
    this.columns = await this.financeiroService.getColumns();
    this.lista().then(() => {
      // Aqui você pode adicionar qualquer lógica que deseja executar após o processamento de lista
      console.log("Lista processada com sucesso!");
    }).catch(error => {
      console.error("Erro ao processar a lista:", error);
    });
  }

  formatReal(int) {
    return (
      "R$ " +
      int
        .toFixed(2)
        .replace(".", ",")
        .replace(/(\d)(?=(\d{3})+\,)/g, "$1.")
    );
  }

  printPage() {
    window.print();
  }

  ajustaData(data: string): string {
    // Ajuste a data para o formato ISO 8601 antes de enviar para o backend
    const dataAjustada = dayjs(data).format("DD/MM/YYYY");
    return dataAjustada;
  }

  ajustaValor(valor: string): number {
    // Remove "R$ ", substitui "." por "" e "," por "."
    const valorAjustado = valor.replace("R$ ", "").replace(/\./g, "").replace(",", ".");
    return parseFloat(valorAjustado);
  }

  geraExcel() {
    const headers = ["Empresa", "Numero", "Parcela", "Vencimento", "Valor"];
    const vencidosHeaders = headers;

    const aVencer = this.listAVencer
    const vencidos = this.listVencidos

    aVencer.forEach(el => {
      el.vencimento = this.ajustaData(el.vencimento)
      return el
    })

    vencidos.forEach(el => {
      el.vencimento = this.ajustaData(el.vencimento)
      return el
    })

    this.financeiroService
      .geraExcel(headers, aVencer, vencidosHeaders, vencidos)
      .subscribe(
        (response) => {
          const blob = new Blob([response], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = url;
          a.download = "arquivo.xlsx";
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        },
        (error) => {
          console.error("Erro ao baixar o arquivo Excel", error);
        }
      );
  }
}
